import { inject, Injectable } from '@angular/core';
import { ToastItem, ToastService, ToastStatus } from '@bpifrance/propulsion';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private readonly toastService = inject(ToastService);

  success(message: string, header: string = 'Succès', delay: number = 5) {
    const toast = this.getToastItem(header, message, 'success', delay);
    this.toastService.addToast(toast);
  }

  info(message: string, header: string = 'Information', delay: number = 5) {
    const toast = this.getToastItem(header, message, 'information', delay);
    this.toastService.addToast(toast);
  }

  error(message: string, header: string = 'Erreur', delay: number = 5) {
    const toast = this.getToastItem(header, message, 'error', delay);
    this.toastService.addToast(toast);
  }

  getToastItem(
    header: string,
    message: string,
    status: ToastStatus,
    delay: number,
  ) {
    return new ToastItem(header, message, status, delay);
  }
}
